import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, toHandlers as _toHandlers } from "vue"

const _hoisted_1 = { class: "user-container" }
const _hoisted_2 = { class: "dialog-card warning" }
const _hoisted_3 = { class: "dialog-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_5 = { class: "dialog-body" }
const _hoisted_6 = { class: "dialog-actions" }
const _hoisted_7 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_9 = { class: "dialog-card warning" }
const _hoisted_10 = { class: "dialog-title" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_12 = { class: "dialog-actions" }
const _hoisted_13 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_15 = { class: "admin-top" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-left" }, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"auto"} }, null, -1)
const _hoisted_20 = { style: {"display":"flex","align-items":"center","gap":"15px"} }
const _hoisted_21 = {
  key: 0,
  class: "options-menu"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-ellipsis-h" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "options-menu-inner animated-fast"
}
const _hoisted_24 = { class: "admin-stage" }
const _hoisted_25 = {
  class: "user-top",
  style: {"display":"block"}
}
const _hoisted_26 = { style: {"margin":"0","margin-bottom":"25px"} }
const _hoisted_27 = { class: "user-details" }
const _hoisted_28 = { class: "column" }
const _hoisted_29 = { class: "user-email-input" }
const _hoisted_30 = { class: "user-email-input" }
const _hoisted_31 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_32 = { style: {"margin-right":"10px"} }
const _hoisted_33 = {
  key: 0,
  class: "inner-stage elevate"
}
const _hoisted_34 = {
  key: 0,
  style: {"padding":"20px","text-align":"center"}
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { style: {"padding":"15px"} }
const _hoisted_37 = { class: "table-search" }
const _hoisted_38 = { style: {"padding":"15px"} }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"100px"} }, null, -1)
const _hoisted_40 = { class: "user-list-item" }
const _hoisted_41 = { class: "name-span" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { style: {"padding":"15px"} }
const _hoisted_44 = { class: "storage-blocks" }
const _hoisted_45 = { class: "storage-block" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "value" }, [
  /*#__PURE__*/_createTextVNode("0.0 "),
  /*#__PURE__*/_createElementVNode("span", { class: "byte-size" }, "GB")
], -1)
const _hoisted_47 = { class: "storage-block" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { style: {"padding":"15px"} }
const _hoisted_50 = { style: {"padding":"0px 15px"} }
const _hoisted_51 = { style: {"display":"flex","align-items":"center","gap":"15px","margin-top":"25px","padding":"15px"} }
const _hoisted_52 = { style: {"padding":"15px"} }
const _hoisted_53 = { class: "multi-delete-container" }
const _hoisted_54 = {
  key: 0,
  class: "multi-delete animated-fast"
}
const _hoisted_55 = { class: "uploaded-by-list-item" }
const _hoisted_56 = { class: "uploaded-by-span" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { style: {"display":"flex","gap":"15px"} }
const _hoisted_59 = { class: "file-list-item" }
const _hoisted_60 = { class: "filename-span" }
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = {
  key: 1,
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_imdex_checkbox = _resolveComponent("imdex-checkbox")!
  const _component_imdex_tab = _resolveComponent("imdex-tab")!
  const _component_imdex_tabs = _resolveComponent("imdex-tabs")!
  const _component_imdex_radio = _resolveComponent("imdex-radio")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_table = _resolveComponent("imdex-table")!
  const _component_imdex_tab_item = _resolveComponent("imdex-tab-item")!
  const _component_imdex_tab_items = _resolveComponent("imdex-tab-items")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_imdex_dialog, {
      value: _ctx.deleteDialog,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      width: "600"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("site.confirmFileDelete")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("site.deleteFileHint")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_imdex_btn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteDialog = false)),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("site.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_imdex_btn, {
                style: {"margin-left":"10px"},
                onClick: _ctx.confirmDeleteFiles
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("site.delete")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _hoisted_8
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_imdex_dialog, {
      value: _ctx.siteDeleteDialog,
      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.siteDeleteDialog) = $event)),
      width: "600"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("site.confirmSiteDelete")), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_imdex_btn, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.siteDeleteDialog = false)),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("site.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_imdex_btn, {
                style: {"margin-left":"10px"},
                onClick: _ctx.deleteSite
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("site.delete")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _hoisted_14
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("input", {
      ref: "avatar-image",
      style: {"opacity":"0","pointer-events":"none","position":"absolute","user-select":"none"},
      type: "file",
      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
    }, null, 544),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_imdex_btn, {
        style: {"margin-right":"15px","font-size":"25pt"},
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.go(-1))),
        text: "",
        compact: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }),
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t("site.create")), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("site.edit")), 1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("site.site")) + " ", 1),
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        (_ctx.editing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_imdex_btn, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showOption = !_ctx.showOption)),
                icon: "",
                text: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_Transition, {
                "enter-active-class": "fadeInUp",
                "leave-active-class": "fadeOutDown"
              }, {
                default: _withCtx(() => [
                  (_ctx.showOption)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.siteDeleteDialog = true)),
                          class: "option-menu-item"
                        }, _toDisplayString(_ctx.$t("site.deleteSite")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.editing)
          ? (_openBlock(), _createBlock(_component_imdex_btn, {
              key: 1,
              onClick: _ctx.submitCreateSite,
              secondary: "",
              loading: _ctx.createLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("site.create")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"]))
          : _createCommentVNode("", true),
        (_ctx.editing)
          ? (_openBlock(), _createBlock(_component_imdex_btn, {
              key: 2,
              onClick: _ctx.submitEditSite,
              secondary: "",
              loading: _ctx.createLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("site.save")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t("site.siteDetails")), 1),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_imdex_text_field, {
                style: {"max-width":"300px"},
                value: _ctx.site.name,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.site.name) = $event)),
                label: _ctx.$t(`site.nameInputLabel`)
              }, null, 8, ["value", "label"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_imdex_text_field, {
                style: {"max-width":"300px"},
                value: _ctx.site.description,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.site.description) = $event)),
                label: _ctx.$t(`site.descInputLabel`)
              }, null, 8, ["value", "label"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_imdex_select, {
                class: "country-select",
                searchable: "",
                style: {"max-width":"300px"},
                value: _ctx.site.country,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.site.country) = $event)),
                label: _ctx.$t(`site.selectCountry`),
                "prepend-icon": "fa-search",
                items: _ctx.countries
              }, null, 8, ["value", "label", "items"])
            ]),
            (_ctx.isSystemAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t(`site.adminOnlyRadioLabel`)), 1),
                  _createVNode(_component_imdex_checkbox, {
                    secondary: "",
                    value: _ctx.site.isSysAdminOnly,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.site.isSysAdminOnly) = $event))
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createVNode(_component_imdex_tabs, {
              value: _ctx.tab,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.tab) = $event))
            }, {
              default: _withCtx((slot) => [
                (_openBlock(), _createBlock(_component_imdex_tab, {
                  onClick: ($event: any) => (slot.scope(0)),
                  key: 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`site.userPermsTab`)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])),
                (_openBlock(), _createBlock(_component_imdex_tab, {
                  onClick: ($event: any) => (slot.scope(1)),
                  key: 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`site.filesAndStorageTab`)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(_component_imdex_tab_items, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tab) = $event))
            }, {
              default: _withCtx(() => [
                (_ctx.site.isSysAdminOnly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t(`site.sysAdminOnlyInd`)), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (_openBlock(), _createBlock(_component_imdex_tab_item, {
                        hidden: _ctx.tab != 0,
                        key: 0
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.$t(`site.userPermsTab`)), 1),
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_imdex_select, {
                              class: "user-select",
                              searchable: "",
                              style: {"max-width":"250px"},
                              value: _ctx.userPermissionSearchTerm,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.userPermissionSearchTerm) = $event)),
                              label: _ctx.$t(`site.selectUser`),
                              "prepend-icon": "fa-search",
                              items: _ctx.searchUsers
                            }, null, 8, ["value", "label", "items"]),
                            _createVNode(_component_imdex_select, {
                              class: "role-select",
                              style: {"max-width":"250px"},
                              value: _ctx.userPermissionSearchRole,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.userPermissionSearchRole) = $event)),
                              items: _ctx.availableRoles,
                              label: _ctx.$t(`site.chooseRole`)
                            }, null, 8, ["value", "items", "label"]),
                            _createVNode(_component_imdex_btn, {
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitAddUserToSite())),
                              outlined: "",
                              secondary: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`site.addUserToSite`)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_imdex_table, { tableData: _ctx.userPermissionTableData }, {
                              "h-name": _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`site.name`)), 1)
                              ]),
                              "h-contributor": _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`site.contributor`)), 1)
                              ]),
                              "h-viewer": _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`site.viewer`)), 1)
                              ]),
                              "h-remove": _withCtx(() => [
                                _hoisted_39
                              ]),
                              remove: _withCtx((prop) => [
                                _createVNode(_component_imdex_btn, {
                                  onClick: ($event: any) => (_ctx.updateSitePermission(prop.row, 'none')),
                                  compact: "",
                                  text: "",
                                  secondary: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(`site.remove`)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              contributor: _withCtx((prop) => [
                                _createVNode(_component_imdex_radio, {
                                  class: "contributor-radio",
                                  onInput: ($event: any) => (_ctx.updateSitePermission(prop.row, 'contributor')),
                                  value: prop.row.contributor,
                                  "onUpdate:value": ($event: any) => ((prop.row.contributor) = $event)
                                }, null, 8, ["onInput", "value", "onUpdate:value"])
                              ]),
                              viewer: _withCtx((prop) => [
                                _createVNode(_component_imdex_radio, {
                                  class: "viewer-radio",
                                  onInput: ($event: any) => (_ctx.updateSitePermission(prop.row, 'viewer')),
                                  value: prop.row.viewer,
                                  "onUpdate:value": ($event: any) => ((prop.row.viewer) = $event)
                                }, null, 8, ["onInput", "value", "onUpdate:value"])
                              ]),
                              name: _withCtx((prop) => [
                                _createElementVNode("div", _hoisted_40, [
                                  _createVNode(_component_imdex_tooltip, {
                                    nudgeY: -10,
                                    class: "name-tooltip"
                                  }, {
                                    activator: _withCtx((on) => [
                                      _createElementVNode("div", _toHandlers(on), [
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(prop.row.name), 1)
                                      ], 16)
                                    ]),
                                    tooltip: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: prop.row.name
                                      }, null, 8, _hoisted_42)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _: 1
                            }, 8, ["tableData"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["hidden"]))
                    ])),
                (_openBlock(), _createBlock(_component_imdex_tab_item, {
                  hidden: _ctx.tab != 1,
                  key: 1
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.$t(`site.storageUse`)), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`site.loadedDatasets`)), 1),
                        _hoisted_46
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`site.uploadedFiles`)), 1),
                        _createElementVNode("span", {
                          class: "value",
                          innerHTML: _ctx.totalSizeText
                        }, null, 8, _hoisted_48)
                      ])
                    ]),
                    _createElementVNode("h3", _hoisted_49, _toDisplayString(_ctx.$t(`site.uploadedFiles`)), 1),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t(`site.deleteRawHint`)), 1),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_imdex_text_field, {
                        searchable: "",
                        style: {"max-width":"250px"},
                        value: _ctx.fileSearchTerm,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.fileSearchTerm) = $event)),
                        label: _ctx.$t(`site.searchInputLabel`),
                        leadingIcon: "fal fa-search"
                      }, null, 8, ["value", "label"]),
                      _createVNode(_component_imdex_select, {
                        style: {"max-width":"250px"},
                        value: _ctx.fileDateRange,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fileDateRange) = $event)),
                        items: _ctx.availableDateRanges,
                        label: _ctx.$t(`site.uploadedDateInputLabel`)
                      }, null, 8, ["value", "items", "label"]),
                      _createVNode(_component_imdex_select, {
                        searchable: "",
                        style: {"max-width":"250px"},
                        value: _ctx.fileUploadedBy,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.fileUploadedBy) = $event)),
                        label: _ctx.$t(`site.uploadedByInputLabel`),
                        leadingIcon: "fal fa-search",
                        items: _ctx.searchFileUsers
                      }, null, 8, ["value", "label", "items"])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_Transition, {
                          "enter-active-class": "slideInUp",
                          "leave-active-class": "slideOutDown"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.selectedFiles.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                  _createTextVNode(_toDisplayString(_ctx.selectedFiles.length) + " " + _toDisplayString(_ctx.$t(`site.filesSelected`)) + " ", 1),
                                  _createVNode(_component_imdex_btn, {
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.deleteDialog = true)),
                                    outlined: "",
                                    compact: "",
                                    secondary: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t(`site.delete`)), 1)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.storageTableData.tableData.length)
                        ? (_openBlock(), _createBlock(_component_imdex_table, {
                            style: {"position":"relative","z-index":"10"},
                            tableData: _ctx.storageTableData,
                            key: _ctx.storageTableRenderKey,
                            onPageChangeFunc: _ctx.toggleSelectAllFiles,
                            ref: "storageTable"
                          }, {
                            "h-select": _withCtx(() => [
                              _createVNode(_component_imdex_checkbox, {
                                value: _ctx.selectAllFiles,
                                "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectAllFiles) = $event))
                              }, null, 8, ["value"])
                            ]),
                            "h-delete": _withCtx(() => []),
                            "h-filename": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`site.filename`)), 1)
                            ]),
                            "h-uploaded": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`site.uploaded`)), 1)
                            ]),
                            "h-uploaded_by": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`site.uploadedBy`)), 1)
                            ]),
                            "h-source": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`site.source`)), 1)
                            ]),
                            "h-size": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`site.size`)), 1)
                            ]),
                            delete: _withCtx((prop) => [
                              _createVNode(_component_imdex_btn, {
                                onClick: ($event: any) => (
											(_ctx.deleteDialog = true),
												(_ctx.deleteFileIds = [prop.row.fileId])
										),
                                text: "",
                                secondary: "",
                                compact: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t(`site.delete`)), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            select: _withCtx((prop) => [
                              _createVNode(_component_imdex_checkbox, {
                                value: prop.row.selected,
                                "onUpdate:value": ($event: any) => ((prop.row.selected) = $event)
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            uploaded: _withCtx((prop) => [
                              _createElementVNode("div", null, _toDisplayString(_ctx.moment(prop.row.uploaded).format("DD/MM/YYYY kk:mm")), 1)
                            ]),
                            uploaded_by: _withCtx((prop) => [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_component_imdex_tooltip, {
                                  nudgeY: -10,
                                  class: "uploaded-by-tooltip"
                                }, {
                                  activator: _withCtx((on) => [
                                    _createElementVNode("div", _toHandlers(on), [
                                      _createElementVNode("span", _hoisted_56, _toDisplayString(prop.row.uploaded_by), 1)
                                    ], 16)
                                  ]),
                                  tooltip: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: prop.row.uploaded_by
                                    }, null, 8, _hoisted_57)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            size: _withCtx((prop) => [
                              _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.formatBytes(prop.row.size)), 1)
                            ]),
                            filename: _withCtx((prop) => [
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_component_imdex_tooltip, {
                                  nudgeY: -10,
                                  class: "filename-tooltip"
                                }, {
                                  activator: _withCtx((on) => [
                                    _createElementVNode("div", _toHandlers(on), [
                                      _createElementVNode("span", _hoisted_60, _toDisplayString(prop.row.filename), 1)
                                    ], 16)
                                  ]),
                                  tooltip: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: prop.row.filename
                                    }, null, 8, _hoisted_61)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _: 1
                          }, 8, ["tableData", "onPageChangeFunc"]))
                        : _createCommentVNode("", true),
                      (!_ctx.storageTableData.tableData.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.$t(`site.noMatchingFiles`)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["hidden"]))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}